import * as React from 'react';
import { IRowCell } from './RemoteTable.types';
import RowCell from './RowCell';

interface IRowProps {
  onClick?(): any;
  cells: IRowCell[];
}

const Row: React.FC<IRowProps> = (props: IRowProps) => {
  const { cells, onClick } = props;
  return (
    <tr
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      {cells.map(cell => {
        return !cell.hide ? (
          <RowCell
            rowStyle={cell.rowStyle}
            key={cell.columnKey}
            align={cell.align}
            value={cell.value}
          />
        ) : null;
      })}
    </tr>
  );
};

export default Row;
